export enum DropdownListType {
  Default = 'default',
  Searchable = 'searchable'
}
